import FormItem from "@components/FormItem/FormItem";
import FormSection from "@components/FormSection/FormSection";
import {
  FORM_FIELDS,
  type VesselNominationOutletContext,
} from "@features/vessel-nomination/add/constants";
import type { VesselNominationFormData } from "@features/vessel-nomination/add/schema/vesselNominationFormSchema";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { LANG_BASE } from "../PreArrivalQuestionnaire";

const DeadWeight = () => {
  const { t } = useTranslation();
  const { formData, updateFormData } = useOutletContext<VesselNominationOutletContext>();

  return (
    <FormProvider {...formData}>
      <FormSection
        title={t(`${LANG_BASE}.sections.dead-weight`)}
        className="grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"
      >
        <FormItem<VesselNominationFormData, typeof FORM_FIELDS.SUMMER_DWT>
          testId="nomination-summer-dwt-input"
          name={FORM_FIELDS.SUMMER_DWT}
          type="number"
          label={t(`${LANG_BASE}.fields.summer-dwt`)}
          onFieldChange={updateFormData}
          maxDigits={12}
          decimals={3}
          adornment="MT"
          thousandSeparator
          canBeginWithZero={false}
        />
        <FormItem<VesselNominationFormData, typeof FORM_FIELDS.TROPICAL_DWT>
          testId="nomination-tropical-dwt-input"
          name={FORM_FIELDS.TROPICAL_DWT}
          type="number"
          label={t(`${LANG_BASE}.fields.tropical-dwt`)}
          onFieldChange={updateFormData}
          maxDigits={12}
          decimals={3}
          adornment="MT"
          thousandSeparator
          canBeginWithZero={false}
        />
      </FormSection>
    </FormProvider>
  );
};

export default DeadWeight;
